module.exports = __webpack_public_path__ + "img/SEL35F14GM.8fa0a5ad.jpg";